import _ from 'lodash';
const flatten = require('flat');

export const flattenJson = (obj: any) => {
  const data = (Array.isArray(obj))? obj : [obj];
  let output: any[] = [];

  for(const key in data) {
    if (!data.hasOwnProperty(key)) continue;
    output = output.concat(unravel(data[key]));
  }

  if(output[0] && (typeof output[0]) === 'object') {
    output = output.map( item => flatten(item));
  }

  return output;
};

export const getAllKeysFromObject = (obj: any): string[] => {
  let key: string;
  let keys: string[] = [];

  if(Array.isArray(obj)) {
    if(obj.length > 0) {
      keys = getAllKeysFromObject(obj[0]);
    }
  }
  else
  {
    for (key in obj) {
      if (!obj.hasOwnProperty(key)) continue;

      if(Array.isArray(obj[key])){
        if(obj[key].length > 0) {
          const child = obj[key][0];
          const childKeys = getAllKeysFromObject(child);
          keys = keys.concat(childKeys.map(childKey => key + '.' + childKey));
        }
      }
      else if ((typeof obj[key]) === 'object')
      {
        const childKeys = getAllKeysFromObject(obj[key]);
        keys = keys.concat(childKeys.map(childKey => key + '.' + childKey));
      }
      else
      {
        keys.push(key);
      }
    }
  }

  return _.uniq(keys);
};


const unravel = (obj: any) => {
  const out = [];
  let added = false;

  for(const i in obj) {
    if(obj[i] instanceof Array) {
      for(const j in obj[i]) {
        if (!obj[i].hasOwnProperty(j)) continue;

        const r = unravel(obj[i][j]);
        for(const k in r) {
          if (!r.hasOwnProperty(k)) continue;
          const a: any = {};
          for(const key in obj) { // make copy of obj
            if (!obj.hasOwnProperty(key)) continue;
            a[key] = obj[key];
          }
          a[i] = r[k];
          added = true;
          out.push(a);
        }
      }
    }
  }
  if(!added) out.push(obj);
  return out;
};

export default flattenJson;